
import DISTRICTS from './districts';

export default {
  name: 'VDistpicker',
  props: {
    province: { type: [String, Number], default: '' },
    city: { type: [String, Number], default: '' },
    area: { type: [String, Number], default: '' },
    hideArea: { type: Boolean, default: false },
    onlyProvince: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    provinceDisabled: { type: Boolean, default: false },
    cityDisabled: { type: Boolean, default: false },
    areaDisabled: { type: Boolean, default: false },
    wrapper: { type: String, default: 'distpicker-address-wrapper' }
  },
  data: function data() {
    return {
      provinces: [],
      cities: [],
      areas: [],
      currentProvince: '',
      currentCity: '',
      currentArea: ''
    };
  },

  watch: {
    currentProvince: function currentProvince(value) {
      this.$emit('province', this.setData(value, this.provinces));
      if (this.onlyProvince) this.emit('selected');
    },
    currentCity: function currentCity(value) {
      this.$emit('city', this.setData(value, this.cities));
      if (this.hideArea) this.emit('selected');
    },
    currentArea: function currentArea(value) {
      this.$emit('area', this.setData(value, this.areas));
      this.emit('selected');
    },
    province: function province(value) {
      this.currentProvince = this.province;
      this.cities = this.getDataList(this.currentProvince, this.provinces);
    },
    city: function city(value) {
      this.currentCity = this.city;
      this.areas = this.getDataList(this.currentCity, this.cities);
    },
    area: function area(value) {
      this.currentArea = this.area;
    }
  },
  created: function created() {
    this.provinces = DISTRICTS;
    this.currentProvince = this.getNameValue(this.province, this.provinces);
    this.cities = this.province ? this.getDataList(this.province, this.provinces) : [];
    this.currentCity = this.getNameValue(this.city, this.cities);
    this.areas = this.city ? this.getDataList(this.city, this.cities) : [];
    this.currentArea = this.getNameValue(this.area, this.areas);
  },

  methods: {
    setData: function setData(value, list) {
      var valueObj = list ? list.find(function (item) {
        return item.name === value;
      }) : null;
      return valueObj ? {
        code: valueObj.code,
        value: valueObj.name
      } : {
        code: '',
        value: ''
      };
    },
    emit: function emit(name) {
      var data = {
        province: this.setData(this.currentProvince, this.provinces)
      };

      if (!this.onlyProvince) {
        this.$set(data, 'city', this.setData(this.currentCity, this.cities));
      }

      if (!this.onlyProvince || this.hideArea) {
        this.$set(data, 'area', this.setData(this.currentArea, this.areas));
      }

      this.$emit(name, data);
    },
    getCities: function getCities() {
      this.currentCity = '';
      this.currentArea = '';
      this.cities = this.getDataList(this.currentProvince, this.provinces);
      this.cleanList('areas');
      if (this.cities.length === 0) {
        this.emit('selected');
      }
    },
    getAreas: function getAreas() {
      this.currentArea = '';
      this.areas = this.getDataList(this.currentCity, this.cities);
      if (this.areas.length === 0) {
        this.emit('selected');
      }
    },


    /**
     * 获取数据信息
     * value code/name
     * list 上一级数据
     */
    getDataList: function getDataList(value, list) {
      var isCode = typeof value === 'number';
      for (var index = 0; index < list.length; index++) {
        var item = list[index];
        if (isCode && item.code === value || !isCode && item.name === value) {
          return item.children;
        }
      }
    },


    /**
     * 获取名称值
     * value code/name
     * list 当前类型数据
     */
    getNameValue: function getNameValue(value, list) {
      if (typeof value === 'number') {
        for (var index = 0; index < list.length; index++) {
          var item = list[index];
          if (item.code === value) {
            return item.name;
          }
        }
      }
      return value;
    },
    cleanList: function cleanList(name) {
      this[name] = [];
    }
  }
};